import {
  alphanumericMessage,
  maxLengthMessage,
  requiredMessage,
} from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 15;

export const carMakeValidator = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(/^[a-z0-9 \-]+$/i, {
    message: alphanumericMessage,
    excludeEmptyString: true,
  });
export const carMakeValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage)
  .matches(/^[a-z0-9 \-]+$/i, alphanumericMessage);
